import styled from '@emotion/styled';
import { COLORS3, FONT, SPACING } from '../../styles/emotion';

export const FilterPillContainer = styled.div<{ iconPosition: 'left' | 'right' }>`
  background: var(--background-screen, ${COLORS3.WHITE_100});
  border: 1px solid var(--text-primary, ${COLORS3.BLACK_100});
  border-radius: 26px;
  cursor: pointer;
  display: flex;
  flex-direction: ${(props) => (props.iconPosition === 'left' ? 'row-reverse' : 'row')};
  align-items: center;
  column-gap: ${SPACING.XS};
  margin: 0 ${SPACING.XS} ${SPACING.XS} 0;
  padding: ${SPACING.XS} ${SPACING.SM};
`;

export const PillLabel = styled.div`
  color: var(--text-primary, ${COLORS3.BLACK_100});
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  white-space: nowrap;
`;
